import Utility from "../../../../Utility";
import {editorStore, generalStore} from "../../../../index";

export function saveToHistory() {
    const newChangesHistory = [...editorStore.changesHistory];
    newChangesHistory.splice(editorStore.historyIndex + 1);
    const nodesHistory = Utility.deepClone(editorStore.nodes);
    const connectionsHistory = Utility.deepClone(editorStore.connections);
    const latestState = {
        nodes: nodesHistory,
        connections: connectionsHistory,
        selectedNodeId: generalStore?.selectedNodeId,
        selectedElements: editorStore?.selectedElements
    }
    newChangesHistory.push(latestState);
    editorStore.latestState = latestState;
    editorStore.changesHistory = newChangesHistory;

    editorStore.historyIndex = editorStore.changesHistory.length;
}